import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../enviroments/environments';

function apiUrl(path: string): string {
  return `${environment.apiUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  private formatErrors(error: any) {
    return throwError(() => error);
  }

  get<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
    return this.http.get<T>(apiUrl(path), { params })
      .pipe(catchError(this.formatErrors));
  }

  post<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.post<T>(apiUrl(path), JSON.stringify(body), { headers: this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  put<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.put<T>(apiUrl(path), JSON.stringify(body), { headers: this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(apiUrl(path))
      .pipe(catchError(this.formatErrors));
  }

  // fetch is already a global function, so avoid naming conflict
  fetchData<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.request<T>('FETCH', apiUrl(path), {
      body: JSON.stringify(body),
      headers: this.setHeaders()
    }).pipe(catchError(this.formatErrors));
  }

  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    // You can add authentication token here if needed
    // const token = this.authService.getToken();
    // if (token) {
    //   headersConfig['Authorization'] = `Token ${token}`;
    // }

    return new HttpHeaders(headersConfig);
  }
}
